
const Me = () => {
    return (
        <>
        <h1>Hiiiii</h1>
        <p>My name is Viraj Choubey and I'm a Computer Science student. I have a passion for software development and enjoy creating applications that help make people's lives easier. Recently, I had the opportunity to develop a movie search application that helps users find information about movies and TV shows.
        <br/><br/>
        I created this application as part of my studies and I am excited to share it with the world. My goal with this project was to create a user-friendly and intuitive application that would be easy for anyone to use.
        <br/><br/>
        When I'm not coding, I enjoy watching movies and listening to songs. I believe that a balance of work and fun is essential for a healthy and happy life.
        <br/><br/>
        Thank you for visiting my website and I hope you enjoy using my movie search application. If you have any questions or feedback, please don't hesitate to get in touch.</p>
        </>
    );
};

export default Me;